import { createContext, useContext, useMemo } from 'react';
import { buildAirlinePack } from './buildAirlinePack';
import { getAirlineBySlug } from './airlines';

const AirlineLandingContext = createContext(null);

export function AirlineLandingProvider({ slug, children }) {
  const value = useMemo(() => {
    const airline = getAirlineBySlug(slug);
    if (!airline) return null;
    return buildAirlinePack(airline);
  }, [slug]);

  if (!value) return null;

  return (
    <AirlineLandingContext.Provider value={value}>
      {children}
    </AirlineLandingContext.Provider>
  );
}

export function useAirlineLanding() {
  const value = useContext(AirlineLandingContext);
  if (!value) {
    throw new Error('useAirlineLanding must be used within AirlineLandingProvider');
  }
  return value;
}
